export type OrganizationDetailTabKey =
  | 'info'
  | 'lc-settings'
  | 'licenses'
  | 'members'
  | 'contract'
  | 'operations'
  | 'payments'

export interface OrganizationDetailTab {
  key: OrganizationDetailTabKey
  label: string
}

const tabKeys = new Set<OrganizationDetailTabKey>([
  'info',
  'lc-settings',
  'licenses',
  'members',
  'contract',
  'operations',
  'payments',
])

export function requestedOrganizationDetailTab(searchParams: URLSearchParams): OrganizationDetailTabKey {
  const requested = searchParams.get('tab')
  return requested && tabKeys.has(requested as OrganizationDetailTabKey)
    ? requested as OrganizationDetailTabKey
    : 'info'
}

export function getOrganizationDetailTabs(
  organizationType: string,
  canManageOrganizations: boolean,
): OrganizationDetailTab[] {
  const isLearningCenter = organizationType === 'learning_center'
  return [
    { key: 'info', label: '기본 정보' },
    { key: 'licenses', label: '라이선스' },
    { key: 'members', label: isLearningCenter ? '센터 구성원' : '멤버' },
    { key: 'contract', label: '계약' },
    ...(isLearningCenter && canManageOrganizations
      ? [
          { key: 'lc-settings' as const, label: 'LC 설정' },
          { key: 'operations' as const, label: 'LC 운영조회' },
          { key: 'payments' as const, label: 'LC 결제내역' },
        ]
      : []),
  ]
}
